import { createAsyncThunk } from '@reduxjs/toolkit';
import { Category } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchCategory, FindCategory, GetCategory } from './interface';

export const findCategory = createAsyncThunk(
  'category/findCategory',
  async (values: FindCategory, { rejectWithValue }) => {
    try {
      const response = await Category.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createCategory = createAsyncThunk(
  'category/createCategory',
  async (values: CreatePatchCategory, { rejectWithValue }) => {
    try {
      const response = await Category.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchCategory = createAsyncThunk(
  'category/patchCategory',
  async ({ id, ...values }: CreatePatchCategory, { rejectWithValue }) => {
    try {
      const response = await Category.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCategory = createAsyncThunk(
  'category/getCategory',
  async ({ id }: GetCategory, { rejectWithValue }) => {
    try {
      const response = await Category.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);